import React, { memo } from 'react'

const GuidePage = ({ isOffline, isAeon }) => {
  return (
    <section className="guide-warp" id="guide">
      <img className="img-full" src="assets/img/Title-bar.png" alt="line-bt" />
      <div className="guide">
        <ul>
          <li>
            <div className="content-step">
              <div className="step">Bước 1</div>
              <p>Chụp hình ảnh răng theo hướng dẫn trên điện thoại/ máy tính bảng.</p>
            </div>
          </li>
          <li>
            <div className="content-step">
              <div className="step">Bước 2</div>
              <p>Nhận kết quả sơ bộ ngay trên màn hình.</p>
            </div>
          </li>
          <li>
            <div className="content-step">
              <div className="step">Bước 3</div>
              {isOffline && isAeon ? (
                <p>Điền tên, SĐT, xác thực OTP để nhận báo cáo chi tiết & voucher điện tử 10.000đ*. Báo cáo sẽ được bảo mật tuyệt đối. Voucher sẽ được gửi sau 24 tiếng kể từ lúc bạn hoàn thành các bước tham gia.</p>
              ) : (
                <p>Điền tên, SĐT, xác thực OTP để nhận báo cáo chi tiết. Báo cáo sẽ được bảo mật tuyệt đối.</p>
              )}
            </div>
          </li>
          {/* {isOffline && (
            <li>
              <div className="content-step">
                <div className="step">Bước 4</div>
                <p>Nếu tham gia trực tiếp tại cửa hàng Central Retails (còn gọi là BigC), bạn sẽ được nhận voucher 10.000đ để mua các sản phẩm P/S.</p>
              </div>
            </li>
          )} */}
        </ul>
      </div>
    </section>
  )
}
export default memo(GuidePage)
